<template>
  <div>
    <el-upload class="avatar-uploader el-upload--text"
               :action="config.baseURL + '/upload/video'"
               :show-file-list="false"
               accept=".mp4"
               :on-success="handleSuccess"
               :on-error="handleError"
               :before-upload="beforeUploadVideo"
               :on-progress="uploadVideoProcess"
    >
      <div slot="trigger" class="mb10" v-if="isShowUploadVideo">
        <el-button type="primary">
          {{showVideoPath ? '重新选择' : '选取文件'}}
        </el-button>
        <span v-if="!unlimited" class="font12 c-999 pl15">请保证视频格式正确，且不超过20M</span>
      </div>
      <video v-if="showVideoPath  && !videoFlag"
             :src="showVideoPath"
             class="video-avatar"
             controls="controls">
        您的浏览器不支持视频播放
      </video>
      <i v-else-if="showVideoPath && !videoFlag"
         class="el-icon-plus avatar-uploader-icon"></i>
      <el-progress v-if="videoFlag == true"
                   type="circle"
                   :percentage="videoUploadPercent"
                   style="margin-top:30px;"></el-progress>
    </el-upload>
  </div>
</template>

<script>
  import config from '@/api/config'

  export default {
    name: 'MyVideo',
    props: {
      value: {
        type: String,
        default: ''
      },
      showUpload: {
        type: Boolean,
        default: true
      },
      // 不限制视频大小
      unlimited: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      value () {
        this.showVideoPath = this.value
      }
    },
    data () {
      return {
        config,
        videoFlag: false, //是否显示进度条
        videoUploadPercent: '', //进度条的进度，
        isShowUploadVideo: true, //显示上传按钮
        showVideoPath: '',
      }
    },
    created () {
      this.isShowUploadVideo = this.showUpload
      this.showVideoPath = this.value
    },
    methods: {
      //上传前回调
      beforeUploadVideo (file) {
        if (this.unlimited) {
          this.isShowUploadVideo = false
          return true
        }
        const isLt20M = file.size / 1024 / 1024 < 20
        if (['video/mp4'].indexOf(file.type) == -1) { //'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb'
          this.$message.error('请上传正确的视频格式')
          return false
        }
        if (!isLt20M) {
          this.$message.error('上传视频大小不能超过20MB哦!')
          return false
        }
        this.isShowUploadVideo = false
      },
      //进度条
      uploadVideoProcess (event, file, fileList) {
        this.videoFlag = true
        this.videoUploadPercent = file.percentage.toFixed(0) * 1
      },
      //上传成功回调
      handleSuccess (res, file) {
        this.isShowUploadVideo = true
        this.videoFlag = false
        this.videoUploadPercent = 0
        if (res.code == 200) {
          this.showVideoPath = res.data
          this.$emit('input', res.data)
        } else {
          this.$message.error('视频上传失败，请重新上传！')
        }
      },
      handleError (res) {
        this.videoFlag = false
        this.$message.error('视频上传失败，请重新上传！')
      }
    }
  }
</script>

<style scoped>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .video-avatar {
    display: block;
    width: 400px;
    height: auto;
  }
</style>
